
import { NoseurObject } from "@rivtn/noseur";
import { BaseService, SanitizedResponse } from "../BaseService";

export interface ICountry {
    name: string;
    code: string;
    status: string;
    logo_url: string;
}

export class CountryService extends BaseService {

    protected static instance: CountryService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!CountryService.instance) CountryService.instance = new CountryService();
        return CountryService.instance;
    }

    queryCountries(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/v1/administration/country", { query: this.normalizeParams(params), cache: true, key: `COUNTRIES` }));
    }

    getCountryByCode(code: string): Promise<SanitizedResponse<ICountry>> {
        return this.report(this.transport.get(`/v1/administration/country/code/${code}`, { cache: true, key: `COUNTRIES_${code}` }));
    }

}
